import { LOCALE_COOKIE, locales, defaultLocale, type Locale } from './config'

// ============================================================================
// 916-д9 · СТРАНИЦА ПОСЛЕДНЕЙ ОШИБКИ — НА ЯЗЫКЕ ЧЕЛОВЕКА.
// ----------------------------------------------------------------------------
// Её рисует Next.js вместо корневого шаблона, когда упал он сам: провайдера
// переводов в этот момент нет, словари недоступны. Поэтому слова — здесь, на
// четырёх языках, а язык — тот же выбор человека, что и везде: cookie, затем
// язык браузера, затем язык по умолчанию.
// ============================================================================

const COPY: Record<Locale, { title: string; hint: string; code: string; retry: string }> = {
  ru: { title: 'Произошла ошибка', hint: 'Что-то пошло не так. Попробуйте обновить страницу.', code: 'Код:', retry: 'Попробовать снова' },
  ro: { title: 'A apărut o eroare', hint: 'Ceva nu a mers bine. Încercați să reîncărcați pagina.', code: 'Cod:', retry: 'Încercați din nou' },
  en: { title: 'Something went wrong', hint: 'An error occurred. Try reloading the page.', code: 'Code:', retry: 'Try again' },
  uk: { title: 'Сталася помилка', hint: 'Щось пішло не так. Спробуйте оновити сторінку.', code: 'Код:', retry: 'Спробувати ще раз' },
}

// Язык страницы ошибки: cookie выбора, затем языки браузера, затем умолчание.
export function globalErrorLocale(cookie: string, browser: readonly string[]): Locale {
  const m = new RegExp(`(?:^|;\\s*)${LOCALE_COOKIE}=([^;]+)`).exec(cookie)
  const all = [m?.[1] ?? '', ...browser].map(v => v.slice(0, 2).toLowerCase())
  return (all.find(v => (locales as readonly string[]).includes(v)) as Locale | undefined) ?? defaultLocale
}

export function globalErrorCopy(locale: Locale) {
  return COPY[locale]
}
